import { ArrowRight, Article } from "@phosphor-icons/react";

const posts = [
  {
    tag: "Training",
    title: "The 20-minute hotel-room workout that actually works.",
    excerpt:
      "No equipment, no excuses, no apology emails to the front desk. The exact circuit I use on the road to keep strength gains intact and the suitcase happy.",
    url: "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/asjucynq_SWS_LeadMagnet_Hotel_Workout.pdf",
  },
  {
    tag: "Mindset",
    title: "You don’t need a “restart.” You need 14 honest days.",
    excerpt:
      "If you’ve been ghosting the gym since September, this one’s for you. Why short, structured returns beat dramatic comebacks — and how to design yours.",
    url: "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/566wuetl_SWS_LeadMagnet_14_Honest_Days.pdf",
  },
  {
    tag: "Nutrition",
    title: "What I eat in a busy week.",
    excerpt:
      "A real-life look at fueling a chaotic week — protein hits, the meals I repeat shamelessly, and the snacks I keep stashed in every bag.",
    url: "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/115i8bd5_SWS_LeadMagnet_Busy_Week_Eating.pdf",
  },
];

export default function FieldNotes() {
  return (
    <section
      id="field-notes"
      data-testid="field-notes-section"
      className="relative px-6 md:px-12 lg:px-20 py-16 lg:py-20 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#FF1B91]" />
              <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">Field Notes</p>
            </div>
            <h2 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter">
              Mindset drops &amp;{" "}
              <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">training notes.</span>
            </h2>
          </div>
          <p className="md:max-w-sm text-white/65 leading-relaxed">
            Long-form thoughts on training, recovery, mindset, and what it really takes to stay consistent. New drops monthly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {posts.map((p, i) => (
            <a
              key={i}
              href={p.url}
              target="_blank"
              rel="noreferrer noopener"
              data-testid={`field-note-${i}`}
              className="group border border-white/10 bg-[#0F0F0F] hover:border-[#FF1B91] transition-all p-7 flex flex-col"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#FF1B91] font-bold border border-[#FF1B91]/40 px-2 py-1">
                  {p.tag}
                </span>
                <Article size={20} weight="bold" className="text-white/30 group-hover:text-[#FF1B91] transition-colors" />
              </div>
              <h3 className="font-body font-semibold text-xl leading-snug mb-4">{p.title}</h3>
              <p className="text-sm text-white/65 leading-relaxed flex-1">{p.excerpt}</p>
              <div className="border-t border-white/10 pt-4 mt-6 flex items-center justify-between">
                <span className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-semibold">Read PDF</span>
                <ArrowRight size={16} weight="bold" className="text-white/40 group-hover:text-[#FF1B91] group-hover:translate-x-1 transition-all" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
